import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { IntentContextProvider } from '../../contexts/Intent/Intent.js';

function withIntent(WrappedComponent) {
  var WithIntentComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return props.intent ? /*#__PURE__*/React.createElement(IntentContextProvider, {
      value: {
        intent: props.intent
      }
    }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      ref: ref
    }))) : /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      ref: ref
    }));
  });
  // For better debugging
  WithIntentComponent.displayName = "withIntent(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
  return WithIntentComponent;
}

export { withIntent };
//# sourceMappingURL=withIntent.js.map
